import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './features/order-tracker';

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container);
root.render(<App />);

if (import.meta.env.MODE !== 'development') {
  const serviceWorkerPath = '/order-tracker/service-worker.js';
  navigator.serviceWorker?.register(serviceWorkerPath);
}
